"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationProviderImpl = void 0;
var Utils_1 = require("../../../utils/Utils");
var FirebaseUtils_1 = require("./../../firebase/FirebaseUtils");
var uuid_1 = require("uuid");
var firebase_1 = require("firebase");
var Future_1 = require("../../../utils/Future");
var UserCache_1 = require("./../../UserCache");
var DataSyncProviderImpl_1 = require("./DataSyncProviderImpl");
var CoreServiceHelper_1 = require("../airabbi/CoreServiceHelper");
var NotificationProviderImpl = (function () {
    function NotificationProviderImpl(cfg) {
        var _this = this;
        this.cfg = cfg;
        this.log = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.cfg.debuggable) {
                (_a = _this.cfg.logger).log.apply(_a, __spreadArray(["[".concat(_this.env, "] ").concat((0, Utils_1.getTimeString)(), " NotificationProviderImpl#")], args, false));
            }
        };
        this.log('NotificationProviderImpl# created!');
        this.dataSyncProvider = new DataSyncProviderImpl_1.DataSyncProviderImpl(cfg);
    }
    NotificationProviderImpl.prototype.sendEventNotify = function (unit, event, message) {
        throw new Error('Method not implemented.');
    };
    NotificationProviderImpl.prototype.subscribeEventNotify = function (unit, event, listener) {
        throw new Error('Method not implemented.');
    };
    NotificationProviderImpl.prototype.init = function (env, cfg) {
        this.env = env;
        if (cfg) {
            this.cfg = cfg;
        }
        return Promise.resolve();
    };
    NotificationProviderImpl.prototype.setDebuggable = function (debuggable) {
        if (this.cfg) {
            this.cfg.debuggable = debuggable;
        }
    };
    NotificationProviderImpl.prototype.createNotification = function (category, receiver, title, subTitle, content) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        if (!category || category.trim().length === 0) {
            return Promise.reject('category cannot be empty');
        }
        if (!receiver || receiver.trim().length === 0) {
            return Promise.reject('receiver cannot be empty');
        }
        if (!title || title.trim().length === 0) {
            return Promise.reject('title cannot be empty');
        }
        if (!subTitle || subTitle.trim().length === 0) {
            return Promise.reject('subTitle cannot be empty');
        }
        if (!content || content.trim().length === 0) {
            return Promise.reject('content cannot be empty');
        }
        var notification = {
            id: (0, uuid_1.v4)(),
            category: category,
            receiver: receiver,
            sender: currentUser.uid,
            title: title,
            subTitle: subTitle,
            content: content,
            sentTime: (0, Utils_1.getNotificationTime)(),
            updated: firebase_1.default.database.ServerValue.TIMESTAMP,
            read: false
        };
        var path = "/units/".concat(currentUser.unit, "/notifications/").concat((0, Utils_1.email2UID)(receiver), "/").concat(notification.id);
        var future = new Future_1.Future(Future_1.futureFunc);
        (0, FirebaseUtils_1.setNode)(path, notification)
            .then(function () {
            CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg)
                .sendEmail([receiver], title, content)
                .then(function (result) {
                _this.log('createNotification# email sent!');
                future.resolve();
            })
                .catch(function (err) { return future.reject(err); });
        })
            .catch(function (err) { return future.reject(err); });
        return future.promise;
    };
    NotificationProviderImpl.prototype.removeNotification = function (receiver, id) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!receiver || receiver.trim().length === 0) {
            return Promise.reject('receiver cannot be empty!');
        }
        if (!id || id.trim().length === 0) {
            return Promise.reject('id cannot be empty!');
        }
        var path = "/units/".concat(currentUser.unit, "/notifications/").concat((0, Utils_1.email2UID)(receiver), "/").concat(id);
        return (0, FirebaseUtils_1.removeNode)(path);
    };
    NotificationProviderImpl.prototype.getNotification = function (id) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!id || id.trim().length === 0) {
            return Promise.reject('notification id cannot be empty!');
        }
        var path = "/units/".concat(currentUser.unit, "/notifications/").concat(currentUser.uid, "/").concat(id);
        return (0, FirebaseUtils_1.getNode)(path)
            .then(function (snapshot) { return Promise.resolve(snapshot.val()); })
            .catch(function (err) { return Promise.reject(err); });
    };
    NotificationProviderImpl.prototype.getNotifications = function () {
        var currentUser = (0, UserCache_1.loadUser)();
        var path = "/units/".concat(currentUser.unit, "/notifications/").concat(currentUser.uid);
        return (0, FirebaseUtils_1.getNode)(path)
            .then(function (snapshot) { return Promise.resolve((0, FirebaseUtils_1.snapshot2List)(snapshot)); })
            .catch(function (err) { return Promise.reject(err); });
    };
    NotificationProviderImpl.prototype.markAsRead = function (id) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!id || id.trim().length === 0) {
            return Promise.reject('notification id cannot be empty!');
        }
        var path = "/units/".concat(currentUser.unit, "/notifications/").concat(currentUser.uid, "/").concat(id);
        return (0, FirebaseUtils_1.updateNode)(path, { read: true });
    };
    NotificationProviderImpl.prototype.markAsUnread = function (id) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!id || id.trim().length === 0) {
            return Promise.reject('notification id cannot be empty!');
        }
        var path = "/units/".concat(currentUser.unit, "/notifications/").concat(currentUser.uid, "/").concat(id);
        return (0, FirebaseUtils_1.updateNode)(path, { read: false });
    };
    NotificationProviderImpl.prototype.listenUnreadNotifications = function (callback) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        var path = "/units/".concat(currentUser.unit, "/notifications/").concat(currentUser.uid);
        this.dataSyncProvider
            .unsubscribe(this.nodeListenUnreadNotifications)
            .then(function () {
            var dataSyncListener = {
                onChanged: function (data) {
                    var notifications = data ? (0, Utils_1.objectToList)(data) : [];
                    callback.onUpdated(notifications.filter(function (n) { return !n.read; }));
                }
            };
            _this.dataSyncProvider
                .subscribe(path, path, dataSyncListener)
                .then(function (dataSyncNode) {
                _this.nodeListenUnreadNotifications = dataSyncNode;
            })
                .catch(function (err) { return _this.log(err); });
        })
            .catch(function (err) { return _this.log(err); });
    };
    NotificationProviderImpl.prototype.listenUnreadNotificationsGlobally = function (callback) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        var path = "/units/".concat(currentUser.unit, "/notifications/").concat(currentUser.uid);
        this.dataSyncProvider
            .unsubscribe(this.nodeListenUnreadNotificationsGlobally)
            .then(function () {
            var dataSyncListener = {
                onChanged: function (data) {
                    var notifications = data ? (0, Utils_1.objectToList)(data) : [];
                    callback.onUpdated(notifications.filter(function (n) { return !n.read; }));
                }
            };
            _this.dataSyncProvider
                .subscribe(path + '_globally', path, dataSyncListener)
                .then(function (dataSyncNode) {
                _this.nodeListenUnreadNotificationsGlobally = dataSyncNode;
            })
                .catch(function (err) { return _this.log(err); });
        })
            .catch(function (err) { return _this.log(err); });
    };
    NotificationProviderImpl.prototype.markAllAsUnread = function () {
        var _this = this;
        var future = new Future_1.Future(Future_1.futureFunc);
        this.getNotifications()
            .then(function (notifications) {
            notifications.forEach(function (n) {
                _this.markAsUnread(n.id)
                    .then(function () { return _this.log(''); })
                    .catch(function (err) { return _this.log(err); });
            });
            future.resolve();
        })
            .catch(function (err) { return future.reject(err); });
        return future.promise;
    };
    NotificationProviderImpl.prototype.stopAllMonitor = function () {
    };
    return NotificationProviderImpl;
}());
exports.NotificationProviderImpl = NotificationProviderImpl;
//# sourceMappingURL=NotificationProviderImpl.js.map